var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
// @ts-ignore
import { AfyPlanBenefitsInfo, AlertAFY, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useGetSteps } from "../../utils/getSteps";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import showToast from "../../services/toast";
import { HeaderTitlePage } from "../../components/resources/headerTitlePage/headerTitlePage";
import { useSummaryFilters } from "../addBusiness/hooks";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { getFlagValue } from "ah_utility/fnxUtils";
import { isVidaActiva } from "../../utils/isVidaActiva";
import { formatRD } from "../../utils/getPrice";
import { useDataPerson, useGetPaymentMode, useGetPerson, usePaymentModeData, usePremiumCalculate, } from "./hooks";
import { useGetCatalogGender } from "./hooks/callApis/callApiCatalogGender";
import { usePlanData } from "./hooks/usePlanData";
import { useLocation } from "react-router-dom";
import { useGetInformationSteps } from "ah_utility/workflow";
import useCompleteStepCalculatePremium from "./hooks/useCompleteStep";
import { useErrorHandling } from "./hooks/useErrorHandling";
import { premiumCalculatePostClearData } from "../../store/premiumCalculate/actions";
import { useDispatch } from "react-redux";
import { getCatalogBusinessClearData } from "../../store/catalog/actions";
import { personClearData } from "../../store/person/actions";
import { alertPROPS } from "./constants/calculate.constants";
export var CalculatePremium = function () {
    var _a, _b;
    var dispatch = useDispatch();
    var steps = useGetSteps();
    var _c = useState(""), paymentMode = _c[0], setPaymentMode = _c[1];
    var _d = useState(""), catalogPaymentMode = _d[0], setCatalogPaymentMode = _d[1];
    var _e = useState(""), numberCard = _e[0], setNumberCard = _e[1];
    var _f = useState(""), paymentModeName = _f[0], setPaymentModeName = _f[1];
    var _g = useState("0"), annualPremium = _g[0], setAnnualPremium = _g[1];
    var _h = useState(0), coverageAmount = _h[0], setCoverageAmount = _h[1];
    var filters = useSummaryFilters().filters;
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var Plan = React.useState(findParamInLocalStorage("Plan"))[0];
    var _j = useState(false), openAlert = _j[0], setOpenAlert = _j[1];
    var _k = useState(""), alertMessage = _k[0], setAlertMessage = _k[1];
    var _l = useState(true), disableNextButton = _l[0], setDisableNextButton = _l[1];
    var planData = Plan === null || Plan === void 0 ? void 0 : Plan["0"];
    var planName = (_a = planData === null || planData === void 0 ? void 0 : planData.name) !== null && _a !== void 0 ? _a : "";
    var listTipoCuenta = [{ id: "1", name: "Tarjetas", value: "TARJETAS" }];
    var projectId = React.useState(findParamInLocalStorage("projectId"))[0];
    var personData = React.useState(findParamInLocalStorage("personData"))[0];
    var _m = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _m[0], setSeeToast = _m[1];
    var cardsOnlyLimit = getFlagValue("afy-cards-only-higher-limit");
    var onlyCreditCard = getFlagValue("afy-validate-only-credit-card");
    var isVidaActivaFlow = isVidaActiva();
    // CALL APIS
    var _o = useGetPaymentMode(true, projectId), responsePaymentMode = _o.responsePaymentMode, loadingPaymentMode = _o.loadingPaymentMode, errorPaymentMode = _o.errorPaymentMode;
    var _p = useGetCatalogGender(true), responseGetCatalog = _p.responseGetCatalog, loadingGetCatalog = _p.loadingGetCatalog, errorGetCatalog = _p.errorGetCatalog;
    var _q = useGetPerson(true, personData), responsePerson = _q.responsePerson, loadingPerson = _q.loadingPerson, errorPerson = _q.errorPerson;
    // END CALL APIS
    var _r = useDataPerson(responsePerson, responseGetCatalog, cardsOnlyLimit, onlyCreditCard, isVidaActivaFlow), rawBirthDate = _r.birthDate, rawGender = _r.gender, rawCreditCardList = _r.creditCardList;
    var _s = useState(""), gender = _s[0], setGender = _s[1];
    var _t = useState(""), birthDate = _t[0], setBirthDate = _t[1];
    var _u = useState([]), creditCardList = _u[0], setCreditCardList = _u[1];
    var _v = useState(null), pendingCalculation = _v[0], setPendingCalculation = _v[1];
    useEffect(function () {
        if (rawGender)
            setGender(rawGender);
        if (rawBirthDate)
            setBirthDate(rawBirthDate);
        if (rawCreditCardList.length > 0)
            setCreditCardList(rawCreditCardList);
    }, [rawGender, rawBirthDate, rawCreditCardList]);
    useEffect(function () {
        if (pendingCalculation && gender && birthDate) {
            calculatePremium(pendingCalculation.coverage, pendingCalculation.mode, pendingCalculation.modeId, pendingCalculation.numberCard);
            setPendingCalculation(null);
        }
    }, [gender, birthDate, pendingCalculation]);
    useEffect(function () {
        if (errorPerson || errorGetCatalog) {
            setPendingCalculation(null);
        }
    }, [errorPerson, errorGetCatalog]);
    var _w = usePlanData(), productCode = _w.productCode, planCode = _w.planCode;
    var _x = usePremiumCalculate(productCode, planCode, birthDate, gender), responseCalculate = _x.responseCalculate, errorCalculate = _x.errorCalculate, loadingCalculate = _x.loadingCalculate, calculatePremium = _x.calculatePremium, lastBody = _x.lastBody;
    var _y = useGetInformationSteps(pathLocation), instanceId = _y.instanceId, workFlowId = _y.workFlowId, currentStep = _y.currentStep, nextStep = _y.nextStep;
    var dataCalculation = {
        gender: gender,
        smokes: false,
        coverageAmount: coverageAmount,
        paymentMode: paymentMode,
        paymentModeName: paymentModeName,
        catalogPaymentMode: catalogPaymentMode,
        planCode: planCode,
        numberCard: numberCard,
    };
    var _z = useCompleteStepCalculatePremium(instanceId, workFlowId, currentStep, nextStep, setSeeToast, dataCalculation, lastBody), onClickNextStep = _z.onClickNext, loadingComplete = _z.loadingComplete, errorComplete = _z.errorComplete, handleClickPrevious = _z.handleClickPrevious;
    useErrorHandling({
        errorGetCatalog: errorGetCatalog,
        errorPerson: errorPerson,
        errorPaymentMode: errorPaymentMode,
        errorCalculate: errorCalculate,
        errorComplete: errorComplete,
        setDisableNextButton: setDisableNextButton,
        setSeeToast: setSeeToast,
    });
    useEffect(function () {
        return function () {
            dispatch(personClearData());
            dispatch(getCatalogBusinessClearData());
        };
    }, []);
    useEffect(function () {
        if ((responseCalculate === null || responseCalculate === void 0 ? void 0 : responseCalculate.annualPremium) !== undefined) {
            setAnnualPremium(String(responseCalculate.annualPremium));
            dispatch(premiumCalculatePostClearData());
        }
    }, [responseCalculate]);
    useEffect(function () {
        setDisableNextButton(Number(annualPremium) <= 0);
    }, [annualPremium]);
    var listModalidadPago = usePaymentModeData(responsePaymentMode).listModalidadPago;
    useEffect(function () {
        if (!paymentMode && listModalidadPago.length > 0) {
            var first = listModalidadPago[0];
            setPaymentMode(first.value);
            setPaymentModeName(first.name);
        }
    }, [listModalidadPago, paymentMode]);
    var coverages = ((_b = planData === null || planData === void 0 ? void 0 : planData.benefits) !== null && _b !== void 0 ? _b : []).map(function (benefit) {
        var useMontoAprobado = isVidaActivaFlow && coverageAmount > 0;
        return {
            id: benefit.id,
            name: benefit.description,
            value: useMontoAprobado
                ? formatRD(coverageAmount)
                : formatRD(benefit.value),
        };
    });
    var handleChangeTerminalTarjeta = function (data) {
        var _a, _b;
        setAnnualPremium("0");
        var coverage = (_a = data.montoAprobado) !== null && _a !== void 0 ? _a : "";
        var mode = data.modalidadPago;
        var modeId = data.modalidadPagoId;
        var numberCard = data.numberCard;
        var isInvalid = coverage === "0" || Number(coverage) < 0;
        setOpenAlert(isInvalid);
        if (isInvalid) {
            setAlertMessage("Esta Tarjeta no aplica para el producto seleccionado");
            return;
        }
        var selected = listModalidadPago.find(function (m) { return m.value === mode || m.id === mode; });
        setPaymentMode(mode);
        setCatalogPaymentMode(modeId);
        setPaymentModeName((_b = selected === null || selected === void 0 ? void 0 : selected.name) !== null && _b !== void 0 ? _b : "");
        setCoverageAmount(Number(coverage));
        setNumberCard(numberCard !== null && numberCard !== void 0 ? numberCard : "");
        if (gender && birthDate) {
            calculatePremium(coverage, mode, modeId, numberCard);
        }
        else {
            setPendingCalculation({ coverage: coverage, mode: mode, modeId: modeId, numberCard: numberCard });
        }
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingPaymentMode ||
                    loadingPerson ||
                    loadingGetCatalog ||
                    loadingCalculate ||
                    loadingComplete, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Calculando..." }), _jsx(HeaderTitlePage, { titlePage: "Calcular prima", breadCrumbs: [], steps: steps }), _jsx("div", __assign({ style: { marginBottom: openAlert ? "15px" : "0" } }, { children: _jsx(AlertAFY, __assign({}, alertPROPS, { description: alertMessage, isOpen: openAlert, onClose: function () { return setOpenAlert(false); } })) })), _jsx(AfyPlanBenefitsInfo, { annualPremium: formatRD(annualPremium), coverages: coverages, listModalidadPago: listModalidadPago, listTerminalTarjeta: creditCardList, listTipoCuenta: listTipoCuenta, planName: planName, previousLabel: "Anterior", onClickPrevious: function () { return handleClickPrevious(); }, onClickNext: function () { return onClickNextStep(); }, onChangeTipoCuenta: function () { }, onChangeTerminalTarjeta: handleChangeTerminalTarjeta, filters: filters, minHeight: openAlert ? "calc(100vh - 222px)" : "calc(100vh - 155px)", nextDisabled: disableNextButton, labelTerminalTarjeta: isVidaActiva() ? "Terminal Tarjeta:" : "Terminal Tarjeta Más Límite:", labelMontoAprobado: isVidaActiva()
                    ? "Monto aprobado (RD$):"
                    : "Monto aprobado Más Límite (RD$):" })] }));
};
